import { IGetArticleRequest, IGetArticleResponse } from '@kurtosys/types/api/wordpress/index.js';

import { WordpressRequest } from '../WordpressRequest.js';

export class GetArticle extends WordpressRequest<IGetArticleRequest, IGetArticleResponse> {
	getExplicitEndpoint = () => '/adviser-edge/wp-json/wp/v2/kurtosys-lms/getArticle';
	get endpointConfiguration() {
		return this.getEndpointConfiguration('wordpress', 'GetArticle');
	}
}
